import type { UserWorkspace } from '@/api/types'

/** What `WORKSPACE_USER_PERMISSION_ADMIN` is on the backend. */
const ADMIN = 'ADMIN'

/**
 * Whether the signed-in user administers the workspace.
 *
 * Two endpoints answer only to an admin and say so rather than reporting it per
 * caller -- reading and setting a table's access list. The alternative to
 * checking here is offering a control that fails, which is worse than not
 * offering it: the refusal reads as a bug rather than as a rule.
 */
export function isWorkspaceAdmin(workspace: UserWorkspace | undefined): boolean {
  return workspace?.permissions === ADMIN
}
